import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import partnerService from "../../../services/partners";
import DetailPageLayout from "../../../components/detail/DetailPageLayout";
import { instanceToken } from "../../../utils/constant";
import { dateInfoItems } from "../../../utils/detailUtils";

const Privilege = ({ homeAlert }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [partner, setPartner] = useState(null);

  useEffect(() => {
    const fetchPartner = async () => {
      try {
        const res = await partnerService.getPartner(instanceToken.token, id);
        setPartner(res.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchPartner();
  }, [id]);

  const handleRemove = async () => {
    try {
      await partnerService.deletePartner(instanceToken.token, id);
      homeAlert("Privilege post have been removed.", false);
      navigate("/privileges");
    } catch (error) {
      console.log(error);
      homeAlert("Error on server!", true);
    }
  };

  return (
    <DetailPageLayout
      title="Privilege Details"
      subtitle="View and manage privilege content"
      breadcrumbs={[
        { label: "Privileges", path: "/privileges" },
        { label: `Privilege (ID - ${id})` },
      ]}
      listPath="/privileges"
      imageUrl={partner?.image_url}
      loading={!partner}
      editPath={partner ? `/updatePartner/${partner.id}` : undefined}
      onRemove={handleRemove}
      contentSections={
        partner
          ? [
              {
                title: "Address (English)",
                value: partner.address_en,
                icon: "notes",
              },
              {
                title: "Address (Myanmar)",
                value: partner.address_mm,
                myanmar: true,
                icon: "notes",
              },
              {
                title: "Phone Note",
                value: partner.phone_note,
                icon: "info",
              },
              {
                title: "Promotion",
                value: partner.promotion,
                icon: "info",
              },
            ]
          : []
      }
      infoItems={
        partner
          ? [
              { label: "ID", value: String(partner.id), icon: "id" },
              {
                label: "Category",
                value: partner.category,
                icon: "category",
                badge: "category",
              },
              { label: "Name (English)", value: partner.name_en, icon: "title" },
              {
                label: "Name (Myanmar)",
                value: partner.name_mm,
                icon: "title",
                myanmar: true,
              },
              { label: "Phone", value: partner.phone, icon: "phone" },
              { label: "Email", value: partner.email, icon: "email" },
              { label: "Link", value: partner.link, icon: "link" },
              ...dateInfoItems(partner),
            ]
          : []
      }
      quickActions={
        partner?.link
          ? [
              {
                label: "Open Link",
                onClick: () => window.open(partner.link, "_blank", "noreferrer"),
              },
            ]
          : []
      }
    />
  );
};

export default Privilege;
